<template>
  PluginClientsList.vue
</template>

<script lang="js">
export default {
    name: 'PluginClients',
}
</script>